<template>
  <div class="d-flex items-center flex-column justify-content-center">
    <span class="loader"></span>
    <p class="text-center text-sm font-weight-normal">{{text}}</p>
  </div>
</template>

<script>
  export default {
    props:{
      text: {
        type: String,
        default: 'Cargando'
      }
    },
  }
</script>

<style>
.loader {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: block;
    margin:20px auto;
    position: relative;
    color: #525f7f;
    box-sizing: border-box;
    animation: animation 1s linear infinite alternate;
  }
  
  @keyframes animation {
    0% {
      box-shadow: -38px -12px ,  -14px 0,  14px 0, 38px 0;
    }
    33% {
      box-shadow: -38px 0px, -14px -12px,  14px 0, 38px 0;
    }
    66% {
      box-shadow: -38px 0px , -14px 0, 14px -12px, 38px 0;
    }
    100% {
      box-shadow: -38px 0 , -14px 0, 14px 0 , 38px -12px;
    }
  }
  
  

</style>